<template>
  <div class="pb-1">
    <!-- loading -->
    <div v-if="this.loadpage == true" class="text-center">
      <b-spinner
        style="width: 5rem; height: 5rem;"
        variant="primary"
        label="Large Spinner"
      />
    </div>
    <!-- pc -->
    <b-card class="d-none d-sm-block" v-if="this.loadpage == false">
      <b-tabs v-model="tabsIndex">
        <b-tab title="Balance เงินไทย">
          <b-card no-body>
            <b-card-body class="d-flex pt-1">
              <div class="d-flex align-items-center mb-1 ">
                <span class="px-0 col-1"> วันที่: </span>
                <flat-pickr v-model="bahtDate" class="form-control" :config="datePickerConfig"/>
                <span class="px-1"> - </span>
                <span class="px-0 col-1"> ถึงวันที่: </span>
                <flat-pickr v-model="bahtDueDate" class="form-control mr-1" :config="datePickerConfig"/>
                <b-button variant="primary" @click="getBalancePage()">ค้นหา</b-button>
              </div>
            </b-card-body>
            <b-table
              :items="this.bahtBalance"
              :fields="bahtFields"
              responsive
              class="position-relative"
            >
              <template #cell(balanceDate)="data">
                {{formatDatetime(data.value)}}
              </template>
              <template #cell(description)="data">
                <span v-if="data.item.income != null">{{data.item.description}}</span>
                <span v-else class="pl-1">{{data.item.description}}</span>
              </template>
              <template #cell(income)="data">
                <div
                  v-if="data.item.income != null"
                  style="color:green"
                  class="text-right"
                >
                  + {{format_price(data.value)}}
                </div>
              </template>
              <template #cell(expense)="data">
                <div
                  v-if="data.item.expense != null"
                  style="color:red"
                  class="text-right"
                >
                  - {{format_price(data.value)}}
                </div>
              </template>
              <template #cell(total)="data">
                <div class="text-right">
                  {{format_price(data.value)}}
                </div>
              </template>
            </b-table>
          </b-card>
        </b-tab>
        <!-- <b-tab title="Balance เงินหยวน">
          <b-card no-body>
            <b-card-body class="d-flex pt-1">
              <div class="d-flex align-items-center mb-1 ">
                <span class="px-0 col-1"> วันที่: </span>
                <flat-pickr v-model="yuanDate" class="form-control" :config="datePickerConfig"/>
                <span class="px-1"> - </span>
                <span class="px-0 col-1"> ถึงวันที่: </span>
                <flat-pickr v-model="yuanDueDate" class="form-control mr-1" :config="datePickerConfig"/>
                <b-button variant="primary" @click="getBalancePage()">ค้นหา</b-button>
              </div>
            </b-card-body>
            <b-table
              :items="this.yuanBalance"
              :fields="yuanFields"
              responsive
              class="position-relative"
            >
              <template #cell(balanceDate)="data">
                {{formatDatetime(data.value)}}
              </template>
              <template #cell(description)="data">
                <span v-if="data.item.income != null">{{data.value}}</span>
                <span v-else class="pl-1">{{data.value}}</span>
              </template>
              <template #cell(income)="data">
                <div
                  v-if="data.item.income != null"
                  style="color:green"
                  class="text-right"
                >
                  + {{format_price(data.value)}}
                </div>
              </template>
              <template #cell(expense)="data">
                <div
                  v-if="data.item.expense != null"
                  style="color:red"
                  class="text-right"
                >
                  - {{format_price(data.value)}}
                </div>
              </template>
              <template #cell(total)="data">
                <div class="text-right">
                  {{format_price(data.value)}}
                </div>
              </template>
              <template #cell(custExchangeId)="data">
                <b-link v-if="data.value" @click="getyuanPaymentPic(data.value)">ดูรูป</b-link>
              </template>
            </b-table>
            <p>
              <b-button class="float-right" variant="primary" size="sm" v-b-modal.exchange>แลกเงินหยวนเป็นบาท</b-button>
            </p>
          </b-card>
        </b-tab> -->
      </b-tabs>
    </b-card>

    <!-- mobile -->
    <b-card class="d-block d-sm-none" v-if="this.loadpage == false">
      <b-tabs v-model="tabsIndex">
        <b-tab title="Balance เงินไทย">
          <div>
            <div class="d-flex align-items-center">
              <span class="px-0 col-2"> วันที่: </span>
              <flat-pickr v-model="bahtDate" class="form-control" :config="datePickerConfig"/>
            </div>
            <div class="pt-1 d-flex align-items-center">
              <span class="px-0 col-2"> ถึงวันที่: </span>
              <flat-pickr v-model="bahtDueDate" class="form-control" :config="datePickerConfig"/>
            </div>
            <b-button class="mt-1" variant="primary" @click="getBalancePage()">ค้นหา</b-button>
          </div>
          <hr class="dense">
          <!-- body -->
          <b-card no-body v-for="(item, index) in bahtBalance" :key="index" role="tablist">
            <b-card-header header-tag="header" class="px-0 py-0" role="tab">
              <b-container>
                <b-row>
                  <b-col class="px-0">
                    <span>{{ dateTimeBaht[index].date }}</span>
                  </b-col>
                  <b-col class="text-right px-0">
                    <span v-if="item.income != null" style="color:green">+ {{format_price(item.income)}}</span>
                    <span v-if="item.expense != null" style="color:red">- {{format_price(item.expense)}}</span>
                  </b-col>
                  <b-col class="text-right px-0">
                    <span>= {{format_price(item.total)}}</span>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="px-0">
                    <span>{{ dateTimeBaht[index].time }}</span>
                  </b-col>
                  <b-col class="px-0">
                    <b-button
                      v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                      variant="flat-primary"
                      class="btn-icon rounded-circle float-right pr-0"
                      v-b-toggle="'baht-'+index"
                    >
                      <span class="when-opened">
                        <feather-icon icon="ChevronUpIcon" />
                      </span>
                      <span class="when-closed">
                        <feather-icon icon="ChevronDownIcon" />
                      </span>
                    </b-button>
                  </b-col>
                </b-row>
              </b-container>
            </b-card-header>
            <b-collapse :id="'baht-'+index" accordion="baht" role="tabpanel">
              <b-card-body class="py-0">
                <span>{{item.description}}</span>
              </b-card-body>
            </b-collapse>
            <hr class="dense my-0">
          </b-card>
        </b-tab>

        <!-- <b-tab title="Balance เงินหยวน">
          <div>
            <div class="d-flex align-items-center">
              <span class="px-0 col-2"> วันที่: </span>
              <flat-pickr v-model="yuanDate" class="form-control" :config="datePickerConfig"/>
            </div>
            <div class="pt-1 d-flex align-items-center">
              <span class="px-0 col-2"> ถึงวันที่: </span>
              <flat-pickr v-model="yuanDueDate" class="form-control" :config="datePickerConfig"/>
            </div>
            <b-button class="mt-1" variant="primary" @click="getBalancePage()">ค้นหา</b-button>
          </div>
          <hr class="dense">
          <b-card no-body >
            <b-card no-body v-for="(item, index) in yuanBalance" :key="index" role="tablist">
              <b-card-header header-tag="header" class="px-0 py-0" role="tab">
                <b-container>
                  <b-row>
                    <b-col class="px-0">
                      <span>{{ dateTimeYuan[index].date }}</span>
                    </b-col>
                    <b-col class="text-right px-0">
                      <span v-if="item.income != null" style="color:green">+ {{format_price(item.income)}}</span>
                      <span v-if="item.expense != null" style="color:red">- {{format_price(item.expense)}}</span>
                    </b-col>
                    <b-col class="text-right px-0">
                      <span>{{format_price(item.total)}}</span>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col class="px-0">
                      <span>{{ dateTimeYuan[index].time }}</span>
                    </b-col>
                    <b-col class="px-0">
                      <b-button
                        v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                        variant="flat-primary"
                        class="btn-icon rounded-circle float-right pr-0"
                        v-b-toggle="'yuan-'+index"
                      >
                        <span class="when-opened">
                          <feather-icon icon="ChevronUpIcon" />
                        </span>
                        <span class="when-closed">
                          <feather-icon icon="ChevronDownIcon" />
                        </span>
                      </b-button>
                    </b-col>
                  </b-row>
                </b-container>
              </b-card-header>
              <b-collapse :id="'yuan-'+index" accordion="yuan" role="tabpanel">
                <b-card-body class="py-0">
                  <span>{{item.description}}</span>
                  <br>
                  <b-link v-if="item.custExchangeId" @click="getyuanPaymentPic(item.custExchangeId)">
                    <u>ดูรูปคลิก</u>
                  </b-link>
                </b-card-body>
              </b-collapse>
              <hr class="dense my-0">
            </b-card>
            <b-button variant="primary" v-b-modal.exchange>แลกเงินหยวนเป็นบาท</b-button>
          </b-card>
        </b-tab> -->
      </b-tabs>
    </b-card>

    <b-modal id="exchange" ref="exchange" hide-footer title="แลกเงินหยวนเป็นบาท" title-class="h4">
      <b-form>
        <b-row class="px-1">
          <b-col cols="12">
            <b-form-group label="เรทแลกคืน :" label-cols-md="4">
              <div>1 หยวน = {{format_price(this.rateYuan)}} บาท</div>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="จำนวนเงินหยวน :" label-cols-md="4">
              <cleave
                v-model="amountYuan"
                class="form-control"
                :raw="false"
                :options="options.amountYuan"
                :placeholder="'ยอดหยวนที่มี ' + this.totalYuan + ' หยวน'"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label-cols-md="4">
              <div v-if="this.checkNull == false">แลกได้ {{format_price(this.totalBaht)}} บาท</div>
            </b-form-group>
          </b-col>
        </b-row>
        <hr class="dense"/>
        <div class="float-right">
          <b-button variant="outline-danger" size="sm" @click="hideModal()">ยกเลิก</b-button>
          <b-button
            class="ml-2"
            variant="primary"
            size="sm"
            :disabled="this.amountYuan == '' || this.loadButton == false"
            @click="exchangeYuanToBaht()"
          >
            <b-spinner v-if="this.loadButton == false" small />
            ดำเนินการ
          </b-button>
        </div>
      </b-form>
    </b-modal>

  </div>
</template>

<script>
import {
  BTable, BAvatar, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput,
  BInputGroupAppend, BButton, BCardBody, BCard, BCardHeader, BCardFooter, BRow, BCol,
  BFormRadioGroup, BFormRadio, BFormTextarea, BImg, BTabs, BTab, BSpinner, BCollapse,
  BContainer, VBToggle, VBModal, BModal, BForm, BLink
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import Cleave from 'vue-cleave-component'
import { format_price, formatDatetime, formatDate_dmy } from '@/views/global_function.js'
import { header_token } from '@/views/token'
import { taobaoService_dotnet } from '@/views/global'
import axios from 'axios'


export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
    'b-modal': VBModal,
  },
  components: {
    BTable, BAvatar, BBadge, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput,
    BInputGroupAppend, BButton, BCardBody, BCard, BCardHeader, BCardFooter, BRow, BCol,
    BFormRadioGroup, BFormRadio, BFormTextarea, BImg, BTabs, BTab, BSpinner, BCollapse,
    BContainer, BModal, BForm, ToastificationContent, BLink,
    flatPickr,
    Cleave,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      bahtDate: null,
      bahtDueDate: null,
      yuanDate: null,
      yuanDueDate: null,
      datePickerConfig: {
        altInput: true,
        altFormat: "d-m-Y",
      },

      bahtBalance: [],
      yuanBalance: [],
      amountYuan: '',
      options: {
        amountYuan: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralPositiveOnly: true
        },
      },
      tabsIndex: 0,
      bahtFields: [
        { key: 'balanceDate', label: 'วันที่' },
        { key: 'description', label: 'รายละเอียด' },
        { key: 'income', label: 'เข้า', thClass: 'text-right' },
        { key: 'expense', label: 'ออก', thClass: 'text-right' },
        { key: 'total', label: 'คงเหลือ(บาท)', thClass: 'text-right' },
      ],
      yuanFields: [
        { key: 'balanceDate', label: 'วันที่' },
        { key: 'description', label: 'รายละเอียด' },
        { key: 'income', label: 'เข้า', thClass: 'text-right' },
        { key: 'expense', label: 'ออก', thClass: 'text-right' },
        { key: 'total', label: 'คงเหลือ(หยวน)', thClass: 'text-right' },
        { key: 'custExchangeId', label: 'ดูรูป', thClass: 'text-center', tdClass: 'text-center'}
      ],

      dateTimeBaht: [],
      dateTimeYuan: [],

      rateYuan: null,
      totalYuan: null,
      totalBaht: null,
      checkNull: true,

      loadpage: true,
      loadButton: true,

    };
  },
  created() {
    this.getBalancePage()
    this.getRateYuan()
    if (this.$route.params.tabsIndex) {
      this.tabsIndex = this.$route.params.tabsIndex
    }
  },
  watch: {
    async amountYuan() {
      if (this.amountYuan != '') {
        var yuan = await Number(this.amountYuan.replace(/,/g, ""))
        this.totalBaht = yuan * this.rateYuan
        this.checkNull = false
        if (yuan > this.totalYuan) {
          this.amountYuan = this.totalYuan.toString()
        }
      } else {
        this.checkNull = true
      }
    },
  },
  methods: {
    format_price,
    formatDatetime,
    formatDate_dmy,
    async getBalancePage() {
      var keepdata= []
      var axios = require('axios');
      var data = JSON.stringify({
        // "customerID": 1,
        "loginToken": this.userData.data.customerInfo.loginToken,
        "bathStartDate": this.bahtDate,
        "bathEndDate": this.bahtDueDate,
        "yuanStartDate": this.yuanDate,
        "yuanEndDate": this.yuanDueDate,
        "isMobile": false
      });

      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'app/Balance/load-balance-page',
        headers: {
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U',
          'Content-Type': 'application/json'
        },
        data : data
      };

      await axios(config)
      .then(function (response) {
        keepdata = response.data
      })
      .catch(function (error) {
        console.log(error);
      });
      this.bahtDate = keepdata.bathStartDate
      this.bahtDueDate = keepdata.bathEndDate
      this.yuanDate = keepdata.yuanStartDate
      this.yuanDueDate = keepdata.yuanEndDate
      this.yuanBalance = keepdata.customerYuanBalances
      this.bahtBalance = keepdata.customerBalances

      this.dateTimeYuan=[]
      for (let i = 0; i < this.yuanBalance.length; i++) {
        var date = 0
        var time = 0
        date = this.yuanBalance[i].balanceDate.slice(0, 10);
        time = this.yuanBalance[i].balanceDate.slice(11, 16);
        this.dateTimeYuan.push({
          date: date,
          time: time
        })
      }
      this.dateTimeBaht=[]
      for (let i = 0; i < this.bahtBalance.length; i++) {

        var date = 0
        var time = 0
        date = this.bahtBalance[i].balanceDate.slice(0, 10);
        time = this.bahtBalance[i].balanceDate.slice(11, 16);
        this.dateTimeBaht.push({
          date: date,
          time: time
        })

      }

      this.loadpage = false
    },
    async getRateYuan() {
      let response = await axios.post(taobaoService_dotnet  + 'app/Balance/load-change-yuan-to-bath',
        { "loginToken": this.userData.data.customerInfo.loginToken },
        { headers: header_token }
      )
      this.rateYuan = response.data.rate
      this.totalYuan = response.data.customerYuanBalance
    },
    async exchangeYuanToBaht() {
      this.loadButton = false
      var keepdata = []
      var axios = require('axios');
      var data = JSON.stringify({
        "loginToken": this.userData.data.customerInfo.loginToken,
        "amountYuan": Number(this.amountYuan.replace(/,/g, ""))
      });
      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'app/Balance/exchange-yuan-to-bath',
        headers: {
          'Authorization': 'Bearer ' + localStorage.getItem('auth_token'),
          'Content-Type': 'application/json'
        },
        data : data
      };

      await axios(config)
      .then(function (response) {
        keepdata = response.data
      })
      .catch(function (error) {
        console.log(error);
      });
      if ( keepdata.status == 'success') {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'สำเร็จ',
            icon: 'CheckIcon',
            text: 'แลกเงินหยวนเป็นบาทเรียบร้อย',
            variant: 'success',
          },
        },
        {
          position: 'top-center',
        })
        await this.$router.push({path: '/'})
        this.$router.push({path: '/finance/balance'})
      }
      this.loadButton = true
    },
    hideModal() {
      this.$refs['exchange'].hide()
      this.amountYuan = ''
    },
    async getyuanPaymentPic(id) {
      let response = await axios.get(taobaoService_dotnet  + 'app/Balance/load-yuan-payment-pic?CustExhangeID=' + id,
        { headers: header_token }
      )
      var check = await response.data.photoLink[0].charAt(response.data.photoLink[0].length - 1)
      if (check == 'g') {
        window.open("/finance/yaun-payment?custExhangeID=" + id);
      } else if (check == 'f') {
        window.open(response.data.photoLink[0]);
      }
    }
  },
};
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
<style lang="scss" scoped>
.collapsed > .when-opened,
  :not(.collapsed) > .when-closed {
      display: none;
  }
</style>